<!--
 * @Author: YH000644 weirongwei@danghuan.com
 * @Date: 2024-11-26 14:56:17
 * @LastEditors:  weirongwei@danghuan.com
 * @LastEditTime: 2024-11-28 11:56:38
 * @FilePath: \eu-eswop-web-external\src\views\order\component\banner.vue
 * @Description:
-->
<template>
  <div class="home">
    <div v-if="isMaxScreen" class="main-content">
      <!-- <img v-if="lang == 'es'" src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/banner-es-pc.png" alt="" class="banner-img"> -->
      <!-- <img v-if="lang == 'en' || lang == 'fr'" src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/banner-en-pc.png" alt="" class="banner-img"> -->
      <span class="text">
        Give Your Device a Second Life <br />
        with Danghuan
      </span>
      <img
        src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/oppoeu-banner-pc.png"
        alt=""
        class="banner-img"
      />
    </div>
    <div v-else class="main-content">
      <!-- <img src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/banner-h5.png" alt="" class="banner-img"> -->
      <!-- <img v-if="lang == 'es'" src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/APP_banner_es@3x.png" alt="" class="banner-img">
      <img v-if="lang == 'en' || lang == 'fr'" src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/APP_banner_en@3x.png" alt="" class="banner-img"> -->
      <span class="text">
        Give Your Device a Second Life <br />
        with Danghuan
      </span>
      <img
        src="https://eswop-europe.oss-eu-central-1.aliyuncs.com/email/oppoeu-banner-h5.png"
        alt=""
        class="banner-img"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { orderReject } from '../../../services/api/brandList.js';
export default {
  name: 'btnDialog',
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
      lang: sessionStorage.getItem('lang') || 'es'
    };
  },
  computed: {
    ...mapState({
      isMaxScreen: state => state.isMaxScreen
    })
  },
  methods: {}
};
</script>
<style scoped lang="less">
.banner-img {
  width: 100%;
}

.main-content{
  position: relative;
  span{
    position: absolute ;
  }
}

@media (max-width: 980px) {
  .text{
    position: absolute;
    left: 5%;
    color: #333;
    font-family: "PingFang SC";
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    top: 35%;
  }
}

@media (min-width: 981px) {
  .text{
    width: 1200px;
    position: absolute;
    left: 50%;
    margin-left: -800px;
    color: #333;
    font-family: "PingFang SC";
    font-size: 42px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    top: 35%;
  }
}
</style>
